import React from "react";
import { Container, Row, Col, Form, } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../assets/styles/Footer.css";
import { FaEnvelope, FaFacebook, FaLinkedin, FaHome, FaDotCircle, FaLocationArrow, FaPhone } from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <footer className="footer-section">
      <Container>
        <Row>

          {/* Links */}
          <Col md={2} className="footer-links">
            <h5>Links</h5>
            <ul>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/')}>Home</button></li>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/serviceDetails')}>Services</button></li>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/')}>Our Process</button></li>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/cloudMembership')}>Cloud Membership</button></li>
            </ul>
          </Col>

          {/* Services */}
          <Col md={2} className="footer-links">
            <h5>Services</h5>
            <ul>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/serviceDetails')}>Web Applications</button></li>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/serviceDetails')}>Mobile Application</button></li>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/serviceDetails')}>Artificial Intelligence</button></li>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/serviceDetails')}>Custom Development</button></li>
            </ul>
          </Col>

          {/* Solutions */}
          <Col md={2} className="footer-links">
            <h5>Solutions</h5>
            <ul>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/')}>Remote Teams</button></li>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/cloudMembership')}>Cloud Membership</button></li>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/')}>Help Desk</button></li>
            </ul>
          </Col>

          {/* Locations & Policies */}
          <Col md={2} className="footer-links">
            <h5>Locations</h5>
            <ul>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/')}>Pakistan</button></li>
              <li><button className="footer-link-btn" onClick={() => handleNavigation('/')}>UK</button></li>
            </ul>
          </Col>
          <Col md={4}>

            <Row >
              <h5>Subscribe</h5>
              <p className="subscribe-p" >Our Latest News, Articles, And Resources, We Will Send To Your Inbox Weekly</p>
            </Row>
            <Row >
              <Form className="newsletter-form pe-4">
                <input type="email" placeholder="Your email" className="email-input" />
              </Form>
              <Row className="newsletter-form pt-2 ps-4">
                <button className="subscribe-button">Subscribe</button>
              </Row>
            </Row>
          </Col>
        </Row>

        {/* Footer Bottom Section */}
        <Row className="footer-bottom">
          <hr className="hr" style={{ margin: 0 }} />
          <Col md={3} className="footer-logo">
            <img src='/assets/asyncVibeLogoWhite.png' alt="asyncVibe Logo" className="logo" />
          </Col>
          <Col md={3} className="contact-details footer-column pt-4" style={{ alignItems: "center", justifyContent: "center", borderLeft: '1px solid grey', paddingLeft: '15px', display: "flex", flexDirection: "column" }}>

            <h5>Contact Us</h5>
            <p><FaPhone /> +92 207110715</p>
          </Col>
          <Col md={3} className="contact-details footer-column pt-4" style={{ alignItems: "center", justifyContent: "center", borderLeft: '1px solid grey', paddingLeft: '15px', display: "flex", flexDirection: "column" }}>
            <h5>Address</h5>
            <p><FaHome /> Lahore Pakistan</p>
            <p><FaLocationArrow /> United Kingdom</p>
          </Col>
          <Col md={3} className="social-icons" style={{ alignItems: "center", justifyContent: "center", borderLeft: '1px solid #1B232E', paddingLeft: '15px', display: "flex", flexDirection: "column" }}>
            <h5>Stay Connected</h5>
            <div className="social-icons-buttons">

            <button
                className="social-icon"
                onClick={() => window.open("", "_blank")}
              >
                <FaFacebook />
              </button>

              <button
                className="social-icon"
                onClick={() => window.open("", "_blank")}
              >
                <FaLinkedin />
              </button>

            </div>
          </Col>
          <hr className="hr" />
        </Row>

        {/* Copyright */}
        <Row className="footer-copyright">

          <Col md={6}>
            <p className="footer-text-color">© 2025 Async Vibe. All rights reserved.</p>
          </Col>
          <Col md={6} className="footer-dots text-hover-color">
            <h6><FaDotCircle size={7} /> Site Map</h6>
            <h6><FaDotCircle size={7} /> Privacy & Policy</h6>
            <h6><FaDotCircle size={7} /> Terms of Use</h6>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;